import Vue from 'vue'
import Router from 'vue-router'
import index from './views/index.vue'
import projectIntro from './views/projectIntro.vue'
import planIntro from './views/planIntro.vue'
import introduce from './views/introduce.vue'
import microLecture from './views/microLecture.vue'


Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/projectIntro',
      name: 'projectIntro',
      component: projectIntro
    },
    {
      path: '/planIntro',
      name: 'planIntro',
      component: planIntro
    },
    {
      path: '/microLecture',
      name: 'microLecture',
      component: microLecture
    },
    {
      path: '/introduce',
      name: 'introduce',
      component: introduce
    }
  ]
})
